import api from "./api";

export interface SystemParameter {
  key: string;
  value: string;
  description?: string;
  category: string;
  is_secret: boolean;
  updated_at?: string;
}

export interface ParameterInput {
  key: string;
  value: string;
  category: string;
  description?: string;
  is_secret?: boolean;
}

export const getSystemParameters = async (): Promise<SystemParameter[]> => {
  const response = await api.get<SystemParameter[]>("/parameters");
  return response.data;
};

export const updateParametersBulk = async (params: ParameterInput[]): Promise<any> => {
  const response = await api.put("/parameters/bulk", params);
  return response.data;
};

export const createParameter = async (param: ParameterInput): Promise<SystemParameter> => {
  const response = await api.put("/parameters", param);
  return response.data;
};

export const deleteParameter = async (key: string): Promise<void> => {
  await api.delete(`/parameters/${encodeURIComponent(key)}`);
};

export const testSMTPConnection = async (config?: any): Promise<any> => {
  const response = await api.post("/parameters/test-smtp", config);
  return response.data;
};
